@if (showHeader) {
    <bs-linear-bet-builder-pick-display-header
        [pick]="pick"
        [selectionState]="selectionState"
        [betslipType]="betslipType"
        [oddsDisplayFormat]="oddsDisplayFormat"
        [showWarnings]="true" />
}

<div>
    <bs-linear-bet-builder-selections-list [pick]="pick" />
</div>

@if (showEditButton) {
    <bs-betslip-betbuilder-edit-pick-button [pick]="pick" [title]="addPicksMessage" [hideIcon]="true" [isLinear]="true" />
}
